<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_manageapprovetoken/_update/update.vue'
export default {
  components: {
    createContent
  }
}
</script>
